import { Pipe, PipeTransform } from '@angular/core';
import { ROLES } from '../constants/roles';

@Pipe({
  name: 'formatRoles',
  standalone: true,
})
export class FormatRolesPipe implements PipeTransform {
  transform(roles?: string[]) {
    if (!roles || roles.length === 0) {
      return 'N.A.';
    }
  
    const priorityOrder = [ROLES.ADMIN, ROLES.CONTRIBUTOR, ROLES.EXPLORER];
    const selectedRole = priorityOrder.find((role) => roles.includes(role));
  
    return selectedRole ? this.capitalize(selectedRole) : 'N.A.';
  }

  private capitalize(text?: string) {
    return text?.charAt(0).toUpperCase() + text.slice(1);
  }
}
